import { render, staticRenderFns } from "./AboutFlyingFreelancers.vue?vue&type=template&id=007851f7"
import script from "./AboutFlyingFreelancers.vue?vue&type=script&lang=js"
export * from "./AboutFlyingFreelancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports